import { useContext, useEffect } from "react";
import UserContext from "../../contexts/userContext";

import Offcanvas from 'react-bootstrap/Offcanvas';
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Button from "react-bootstrap/Button";

import { convertToFloat, isAdmin } from "../../utils";

//TODO make environment variable or read in from Dynamo
const llms = [
    {
        id: "claude-instant",
        name: "claude1.2-instant",
        model_id: "anthropic.claude-instant-v1",
        kwargs: {
            max_tokens_to_sample: 2048,
            temperature: .7,
            top_k: 250,
            top_p: 0.999,
            stop_sequences: ["\nHuman:"]
        },
        numRagChunks: 7
    },
    {
        id: "claude3-sonnet",
        name: "claude3-sonnet",
        model_id: "anthropic.claude-3-sonnet-20240229-v1:0",
        kwargs: {
            max_tokens: 2048,
            temperature: .7,
            top_k: 250,
            top_p: 0.999,
            stop_sequences: ["\nHuman:"]
        },
        numRagChunks: 7
    },
    {
        id: "claude3-haiku",
        name: "claude3-haiku",
        model_id: "anthropic.claude-3-haiku-20240307-v1:0",
        kwargs: {
            max_tokens: 2048,
            temperature: .7,
            top_k: 250,
            top_p: 0.999,
            stop_sequences: ["\nHuman:"]
        },
        numRagChunks: 7,
        isDefault: true
    }
];

export const SettingsSidebar = ({show, setShow}) => {
    const { userContext, setUserContext } = useContext(UserContext);
    const isAuthenticated = userContext && userContext.account;

    const setModel = (event) => {
        let selectedModel;
    
        if (typeof userContext.model === 'undefined') {
            const defaultModel = llms.filter(x => x.isDefault)[0];
            selectedModel = {...defaultModel};
        } else {
            selectedModel = {...userContext.model};
            if (event) {
                if (event.type === 'click') {
                    const clickedModelId = event.target.id;
                    const clickedModel = llms.filter(x => x.id === clickedModelId)[0];
                    selectedModel = {...clickedModel};
                } else if (event.type === 'change') {
                    const arg = event.target.attributes.arg.value;
                    switch (arg) {
                        case 'numRagChunks':
                            selectedModel.numRagChunks = convertToFloat(event.target.value);
                            break;
                        case 'stop_sequences':
                            selectedModel.kwargs[arg] = JSON.parse(event.target.value);
                            break;
                        default:
                            selectedModel.kwargs[arg] = convertToFloat(event.target.value);
                    }
                }
            }
        }
        delete selectedModel.isDefault;
    
        const tempUserContext = {...userContext};
        tempUserContext.model = selectedModel;
        setUserContext(tempUserContext);
    }
    useEffect(setModel, []);

    const toggleShowAllDocs = () => {
        const showAllDocs = userContext.showAllDocs && true;
        const tempUserContext = {...userContext};
        tempUserContext.showAllDocs = !showAllDocs;
        setUserContext(tempUserContext);
    }

    const doTour = () => {
        const tempUserContext = {...userContext};
        tempUserContext.tour = true;
        setUserContext(tempUserContext);
        setShow(false);
    }
    
    return <Offcanvas
        show={show}
        onHide={() => setShow(false)}
        placement={'end'}
    >
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className='h5 text-muted mb-3'>Expert Settings</div>
            <Dropdown>
                <Dropdown.Toggle variant="primary" className="mb-2" style={{ width: '100%' }}>
                    {userContext.model ? userContext.model.name : ''}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {llms.map(model => {
                        return (
                            <Dropdown.Item
                                key={model.id}
                                id={model.id}
                                onClick={clickEvent => setModel(clickEvent)}
                            >
                                {model.name}
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        
            {userContext.model && Object.keys(userContext.model.kwargs).map(arg => {
                return (
                    <FloatingLabel
                        key={`${userContext.model.id}${arg}`}
                        label={arg}
                        className="mb-2"
                    >
                        <Form.Control
                            type="text"
                            arg={arg}
                            value={JSON.stringify(userContext.model.kwargs[arg])}
                            onChange={changeEvent => setModel(changeEvent)}
                        />
                    </FloatingLabel>
                );
            })}

            {userContext.model && 
                <FloatingLabel
                    label="numRagChunks"
                    className="mb-2"
                >
                    <Form.Control
                        type="text"
                        arg="numRagChunks"
                        value={userContext.model.numRagChunks}
                        onChange={changeEvent => setModel(changeEvent)}
                    />
                </FloatingLabel>
            }
            
            {isAuthenticated && isAdmin(userContext.account.username) && (
                <>
                    <br />
                    <br />
                    <div className='h5 text-muted'>Administration</div>
                    <Form.Check
                        type="checkbox"
                        label="Show all users' documents"
                        checked={userContext.showAllDocs}
                        className="py-2"
                        onChange={toggleShowAllDocs}
                    />

                    <Button
                        variant="primary"
                        onClick={doTour}
                    >
                        Emulate New User
                    </Button>
                </>
            )}
        </Offcanvas.Body>
    </Offcanvas>

};